import { lessons } from "@/data/course";
import { passageList } from "@/data/passage-list";
import { stories } from "@/data/stories";
import { catalog } from "@/lib/catalog";
import { GAMES } from "@/lib/games/catalog";
import { useT } from "@/lib/i18n";
import { cn } from "@/lib/utils";

/** What the site holds, counted from the content itself so the numbers never go stale. */
/** Rounded down with a plus: 128 → "120+", 24 → "20+". */
const round = (n: number) => `${(n >= 1000 ? Math.floor(n / 1000) * 1000 : n >= 20 ? Math.floor(n / 10) * 10 : Math.floor(n / 5) * 5).toLocaleString("en-IN")}+`;

const STATS = [
  { value: 55000, hi: "शब्द", en: "Dictionary words", emoji: "🔍", color: "text-[#0f766e]", bg: "bg-[#ddf6f3]" },
  { value: lessons.length, hi: "पाठ", en: "Lessons", emoji: "📚", color: "text-[#0e5c8a]", bg: "bg-[#e4f5ff]" },
  { value: catalog.length, hi: "व्याकरण विषय", en: "Grammar topics", emoji: "🧩", color: "text-[#6c4ce8]", bg: "bg-[#efeaff]" },
  { value: GAMES.length, hi: "खेल", en: "Games", emoji: "🎮", color: "text-[#b3214a]", bg: "bg-[#ffedf2]" },
  { value: stories.length, hi: "चित्र-कथाएँ", en: "Picture stories", emoji: "🌳", color: "text-[#0d7552]", bg: "bg-[#e3f9ef]" },
  { value: passageList.length, hi: "पाठ-वाचन", en: "Reading passages", emoji: "📖", color: "text-[#865600]", bg: "bg-[#fff4d6]" },
];

/** A row of big numbers. `english` keeps it English on the English-only landing page. */
export function SiteStats({ english = false, className }: { english?: boolean; className?: string }) {
  const t = useT();
  const tr = (hi: string, en: string) => (english ? en : t(hi, en));
  return (
    <dl className={cn("grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-6", className)}>
      {STATS.map((s) => (
        <div key={s.en} className={cn("flex flex-col items-center rounded-3xl px-3 py-5 text-center", s.bg)}>
          <span aria-hidden className="text-2xl">
            {s.emoji}
          </span>
          <dd className={cn("mt-1 font-display text-3xl font-extrabold leading-none", s.color)}>{round(s.value)}</dd>
          <dt className="deva mt-1 text-sm font-bold text-foreground/75">{tr(s.hi, s.en)}</dt>
        </div>
      ))}
    </dl>
  );
}
